import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChatMessageSearchItem } from '../../../types/chat-session.types';

@Component({
    selector: 'chat-search-messages',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chat-search-messages.component.html',
    styleUrls: ['./chat-search-messages.component.scss'],
})
export class ChatSearchMessagesComponent {
    @Input() public messages: ChatMessageSearchItem[] = [];
    @Output() public messageSelected = new EventEmitter<ChatMessageSearchItem>();
}
